import { render, staticRenderFns } from "./CCSftpCredentials.vue?vue&type=template&id=f4ab682e"
import script from "./CCSftpCredentials.vue?vue&type=script&lang=js"
export * from "./CCSftpCredentials.vue?vue&type=script&lang=js"
import style0 from "./CCSftpCredentials.vue?vue&type=style&index=0&id=f4ab682e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports